import { useEffect } from 'react';

let _imboxInit = false;
const useImboxWithRetailer = (id: string | null = null) => {
  useEffect(() => {
    if (window.initImBox && !_imboxInit && id) {
      _imboxInit = true;
      window.initImBox(id);
    }

    return () => {
      _imboxInit = false;
    };
  }, [id]);

  return { isInitialized: _imboxInit };
};

export default useImboxWithRetailer;
